<template>
    <transition>
    <div class="filter-box" v-if="show" @click.stop>
        <i class="iconfont icon-guanbi" @click="show=false"></i>
        <div class="filter-top-box">{{ title }}</div>
        <div class="filter-body">
            <div class="filter-item" v-if="isShow('plate')">
                <p>所属平台：</p>
                <el-radio-group @input="changeType($event,'plate')" v-model="filterOpt.plate">
                    <el-radio :label="1">校企资源</el-radio>
                    <el-radio :label="0">云资源</el-radio>
                </el-radio-group>
            </div>
            <div class="filter-item" v-if="isShow('ssfl')">
                <p>所属分类：</p>
                <div class="category-box">
                    <div v-for="(item,index) in Category" @click="changeType(item,'ssfl')" :class="{active:item.value==filterOpt.ssfl}" class="category-item" :key="index">{{ item.label }}</div>
                </div>
            </div>
            <div class="filter-item" v-if="isShow('zyfl')">
                <p>资源分类：</p>
                <div class="category-box">
                    <div v-for="(item,index) in resTypeOptions" @click="changeType(item,'zyfl')" :class="{active:item.value==filterOpt.zyfl}" class="category-item" :key="index">{{ item.label }}</div>
                </div>
            </div>
            <div class="filter-item" v-if="isShow('zygs')">
                <p>资源格式：</p>
                <div class="category-box">
                    <div v-for="(item,index) in baseResOpts" @click="changeType(item,'zygs')" :class="{active:item.value==filterOpt.zygs}" class="category-item" :key="index">{{ item.label }}</div>
                </div>
            </div>
            <slot></slot>
        </div>
    </div>
    </transition>
</template>

<script>
import { Category } from '@/utils/utils';
    export default {
        props:{
            filterOpt:{
                require:false,
                default:()=>{}
            },
            title:{
                require:false,
                default:'课程筛选'
            }
        },
        data(){
            return {
                show:false,
                Category:[
                    {
                        label:'全部',
                        value:''
                    },
                    ...Category
                ],
                /**资源分类 */
                resTypeOptions:[
                    {
                        label:'基础资源',
                        value:'base'
                    },
                ],
                /**基础资源类型可选项 */
                baseResOpts:[
                    {
                        label:'全部',
                        value:''
                    },
                    {
                        label:'动画',
                        value:'动画'
                    },
                    {
                        label:'模型',
                        value:'模型'
                    },
                    {
                        label:'文档',
                        value:'文档'
                    },
                    {
                        label:'视频',
                        value:'视频'
                    },
                    {
                        label:'ppt',
                        value:'ppt'
                    },
                    {
                        label:'图片',
                        value:'图片'
                    },
                ],
            }
        },
        methods:{
            changeType(item,type){
                var obj={};
                obj[type]=(type=='plate'?item:item.value);
                this.$emit('change_type',obj);
            },
            isShow(str){
                if(!this.filterOpt)return false;
                for(let key in this.filterOpt){
                    if(str==key)return true;
                }
                return false;
            }
        },
        mounted(){
            window.addEventListener('click',()=>{
                if(this.show){
                    this.show=false;
                }
            })
        },
    }
</script>

<style lang="less" scoped>
.icon-guanbi{
    position: absolute;
    cursor: pointer;
    right: 2rem;
    top: 2rem;
    color: #334681;
    font-size: 16px;
}
.filter-box{
    z-index: 999;
}
.v-enter-active{
  animation: slide-in 0.3s ease;
  opacity: 1;
}
.v-leave-active {
  animation: slide-out 0.3s ease;
  opacity: 0;
}
@keyframes slide-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity:1;
  }
}
@keyframes slide-out {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.category-box{
    display: flex;
    &> :nth-child(n){
        margin-left: 3.5rem;
    }
    &> :nth-child(1){
        margin-left: 0;
    }
    .category-item{
        padding: 0.2rem 1rem;
        border-radius: 1rem;
        color: #334681;
        background-color: transparent;
        cursor: pointer;
    }
}
.filter-box{
    background: #ffffff;
    position: relative;
    border-radius: 16px;
    box-shadow: 0px 0px 16px 0px rgba(180,190,220,0.30); 
    position: fixed;
    top: 17rem;
    right: 2.5rem;
    width: 80rem;
    .filter-top-box{
        padding: 1.7rem 3.6rem;
        color: var(--blue);
        font-size: 16px;
        font-weight: 700;
        box-shadow: 0px 0px 0.9rem 0px rgba(180,190,220,0.15); 
    }
    .filter-body{
        padding: 3.2rem 3.6rem;
        &> :nth-child(n){
            margin-top: 3rem;
        }
        &> :nth-child(1){
            margin-top: 0;
        }
        .filter-item{
            color: #8590B3;
            font-size: 12px;
            display: flex;
            align-items: center;
            &> :nth-child(1){
                margin-right: 1rem;
            }
        }
    }
}
.active{
    color: #ffffff !important;
    background-color: var(--blue) !important;
}
.active-1{
    opacity: 0 !important;
    height: 0 !important;
}
</style>